<template>
    <div class="page home-page">
        <v-container class="pa-lg-12">
            <questionnaire />
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Questionnaire from '@/components/custom/questionnaire'

export default {
  name: "Home",
  components: {
      Questionnaire
  },
  data(){
      return {

      }
  },
  computed: {
      ...GlobalComputed
  },
  methods: {
      ...GlobalMethods
  }
};
</script>
